import React from 'react';
const FormField = ({ errorMessage, id, label, placeholder, required, value, disabled, onChange, }) => {
    return (React.createElement("div", { className: "form-input-container " },
        React.createElement("label", { className: "form-label", htmlFor: id }, label),
        React.createElement("input", { id: id, className: "form-input form-input--text ", placeholder: placeholder, required: required, type: "text", value: value, onChange: onChange, disabled: disabled ?? false }),
        errorMessage && React.createElement("span", { className: "field-validation-error" }, errorMessage)));
};
export default FormField;
